import { IAppState } from '../reducers/index';
import { ItemType } from '../classes/item-type';

export function packageQuantityCheck(props: IAppState, router: { history: { push: (path: string) => void } }) {
    const packageTicketQuantity = (window as any).packageTicketQuantity;
    const isSetQuantityPackage = props.appSettingsModel.itemType === ItemType.Flex || props.appSettingsModel.itemType === ItemType.Super;
    const quantityNotSetServerside = packageTicketQuantity === undefined || packageTicketQuantity.length === 0;
    const quantityNotSetClientside = props.priceTypesModel.priceTypes.filter(pt => pt.selectedQuantity > 0).length === 0;
    const isVariablePricingPackage = props.appSettingsModel.isVariablePriceType;

    if (
        (isSetQuantityPackage && quantityNotSetServerside && quantityNotSetClientside && !isVariablePricingPackage) ||
        (props.appSettingsModel.itemType === ItemType.Flex && props.appSettingsModel.isFlexpackageConflictResolutionRequired)
    ) {
        router.history.push("/ticket-select");
        return;
    }
}